import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ConsentService } from "src/app/services/consent.service";
import { CAConstant } from "src/app/shared/constant";
import { finalize } from "rxjs";
import { LoadingBarComponent } from "../loading-bar/loading-bar.component";
import moment from "moment";
import { ApiResponse } from "src/app/models/apiresponse";

@Component({
  selector: "app-consent",
  imports: [],
  templateUrl: "./consent.component.html",
  styleUrl: "./consent.component.scss",
  standalone: false,
})
export class ConsentComponent implements OnInit {
  @ViewChild(LoadingBarComponent) loadingBar: LoadingBarComponent | any;
  caId: string = "";
  message: string | null = null;
  status: string = "alert";
  title: string | null = null;

  dateAccepted: string = "";
  timeAccepted: string = "";
  statusConfig: any = {
    success: {
      icon: "fa-solid fa-check",
      color: "success",
    },
    alert: {
      icon: "fa-solid fa-xmark",
      color: "alert",
    },
    acknowledged: {
      icon: "fa-solid fa-circle-check",
      color: "acknowledged",
    },
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    public consentServices: ConsentService,
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((p) => {
      this.caId = p["caid"];
    });

    if (!this.caId) {
      this.status = "alert";
      this.title = CAConstant.CONSENT.REQUIRED_CAID;
      return;
    }
    this.acceptConsent();
  }

  acceptConsent() {
    this.consentServices
      .acceptConsent(this.caId)
      .pipe(
        finalize(() => {
          this.loadingBar.hide();
        }),
      )
      .subscribe((res) => {
        if (res.status === CAConstant.SUCCESS_STATUS) {
          console.log(res); // to be remove
          if (!res.responseData) {
            this.status = "alert";
            this.title = CAConstant.CONSENT.CAID_NOT_FOUND;
          } else {
            if (res.responseData.status === CAConstant.CONSENT.EXPIRED_STATUS) {
              this.status = "alert";
              this.title = CAConstant.CONSENT.EXPIRED_TITLE;
            } else if (
              res.responseData.status === CAConstant.CONSENT.ACCEPTED_STATUS &&
              !res.responseData.new
            ) {
              this.status = "acknowledged";
              this.title = CAConstant.CONSENT.ACKNOWLEDGED_TITLE;
              this.message = CAConstant.CONSENT.ACKNOWLEDGED_TEXT.replace(
                "{dateAccepted}",
                moment(res.responseData.updateddate).format("DD/MM/YYYY"),
              ).replace(
                "{timeAccepted}",
                moment(res.responseData.updateddate).format("hh:mm a"),
              );
            } else if (
              res.responseData.status === CAConstant.CONSENT.ACCEPTED_STATUS &&
              res.responseData.new
            ) {
              this.status = "success";
              this.title = CAConstant.CONSENT.ACCEPT_TITLE;
              if (res.responseData.txnType === "2") {
                this.message = CAConstant.CONSENT.ACCEPT_TEXT_EMAIL;
              }
              if (res.responseData.txnType === "1") {
                this.message = CAConstant.CONSENT.ACCEPT_TEXT_SSTC;
              }
            } else {
              this.status = "alert";
              this.title = "Error";
              this.message =
                "There seems to be a problem performing your action, please try again.";
            }
          }
        } else {
          this.handleError(res);
        }
      });
  }

  private handleError(error: ApiResponse) {
    this.status = "alert";
    this.title = "ERROR";
    this.message = error.message;
  }
}
